export const PENDO_API_KEY = "a5477186-b8da-410b-a703-67a74e350a9f";
export const PENDO_CDN_BASE_URL = "https://cdn.pendo.io";
export const PENDO_APPROVED_COUNTRIES_API_URL =
  "https://pcc-671521592931.europe-west1.run.app/pendo-approved-countries";
